import fileSaver from 'file-saver';
import moment from 'moment';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './Costing.type';
import { getSeasons, getSupplier, getUserSuppliers as getUserSuppliersService } from '../../../../../services/supplierSuggestion.service';
import { getAllBrands, getAllCategory } from '../../../../../services/supplier.service';
import { addMultiCommentOfCostingService, exportExcelService, exportToPdfService, getCostingStatsService, getSampleRequestsTodoListService, getSupplierBrands as getSupplierBrandsService, getTodolistCountService } from '../../../../../services/todo-list.service';
import { getMainSamples as getMainSamplesService, getOtherSamples as getOtherSamplesService, getSampleTraking as getSampleTrakingService } from '../../../../../services/sample.service';
import { getAllSampleStatus } from '../../../../../services/SystemMaster.services';
import { imageUrl } from '../../../../../Components/helper';
import type { ApiResponse, CostingListParams, CostingRecord, CostingStats, CostingThunkAction, NamedRef } from './Costing.type';

/**
 * Narrows an unknown catch variable to a display string. Replaces the JavaScript's
 * `err.toString()`, which is not valid under useUnknownInCatchVariables.
 */
const toMessage = (err: unknown): string => (err instanceof Error ? err.message : String(err));

export const getSeasonsAction =
  (id: unknown): CostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await getSeasons(id)) as ApiResponse;
      if (res.code === 200 && res.data) {
        return res.data;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getCostingList =
  (pramams: CostingListParams): CostingThunkAction<Promise<CostingRecord[] | undefined>> =>
  async (dispatch) => {
    const requestId = pramams.requestId || Date.now().toString();
    try {
      const res = (await getSampleRequestsTodoListService(pramams)) as ApiResponse<{
        doc?: CostingRecord[];
        totalCount?: number;
        expandedStats?: CostingStats;
      }>;
      if (res?.code === 200) {
        await dispatch({
          type: t.SET_COSTING_REQUESTS_TODOLIST,
          payload: {
            data: res.data?.doc as CostingRecord[],
            totalCount: res.data?.totalCount as number,
            searchText: pramams.searchText,
            isScrolled: pramams.isScrolled,
            averageTotalCal: res.data?.expandedStats,
            requestId,
          },
        });
        return res.data?.doc;
      }
      /* Preserves a latent quirk of the original: on a non-200 the envelope's `data` object is
         returned rather than a row array, and Costing.tsx stores it verbatim. */
      return res?.data as unknown as CostingRecord[] | undefined;
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const fetchAllBrandAction =
  (params: unknown): CostingThunkAction<Promise<NamedRef[] | undefined>> =>
  async () => {
    try {
      const res = (await getAllBrands(params)) as ApiResponse<NamedRef[]>;
      if (res.code === 200 && res.data) {
        return res.data;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getSuppliers =
  (data: { loggedInUserId?: string | undefined }): CostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await getSupplier(data)) as ApiResponse<{ errMsg?: string }>;
      if (res.code === 200) {
        return res.data;
      }
      toasterMsg(res.data!.errMsg, 'danger');
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getUserSuppliers =
  (): CostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await getUserSuppliersService()) as ApiResponse<{ errMsg?: string }>;
      if (res.code === 200) {
        return res.data;
      }
      toasterMsg(res.data!.errMsg, 'danger');
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getMainSamples =
  (pramams: unknown): CostingThunkAction<Promise<unknown>> =>
  async (dispatch) => {
    try {
      const res = (await getMainSamplesService(pramams)) as ApiResponse<unknown[]>;
      if (res?.code === 200) {
        await dispatch({
          type: t.GET_MAIN_SAMPLES,
          payload: res.data as unknown[],
        });
        return res.data;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getSampleStatus =
  (params: unknown): CostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await getAllSampleStatus(params)) as ApiResponse;
      return res.data;
    } catch (error) {
      toasterMsg(toMessage(error), 'danger');
    }
    return undefined;
  };

export const fetchCategoryAction =
  (params: unknown): CostingThunkAction<Promise<unknown>> =>
  async (dispatch) => {
    const setValueObj = (label: string, value: string) => {
      return { label, value };
    };
    try {
      const res = (await getAllCategory(params)) as ApiResponse<Array<{ label: string; value: string }>>;
      if (res.code === 200 && res.data) {
        const category = res.data.map((item) => {
          return setValueObj(item.label, item.value);
        });
        await dispatch({
          type: t.CATEGORY,
          payload: category,
        });
        return res.data;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getOtherSamples =
  (pramams: unknown): CostingThunkAction<Promise<unknown>> =>
  async (dispatch) => {
    try {
      const res = (await getOtherSamplesService(pramams)) as ApiResponse;
      if (res?.code === 200) {
        await dispatch({
          type: t.GET_OTHER_SAMPLES,
          payload: res.data,
        });
        return res.data;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const getSampleTraking =
  (): CostingThunkAction<Promise<unknown>> =>
  async () => {
    try {
      const res = (await getSampleTrakingService()) as ApiResponse<{ errMsg?: string }>;
      if (res?.code === 200) {
        return res.data;
      }
      toasterMsg(res.data!.errMsg, 'danger');
    } catch (error) {
      toasterMsg(toMessage(error), 'danger');
    }
    return undefined;
  };

export const getCostingTodolistCount =
  (pramams: { type?: string }): CostingThunkAction<Promise<boolean | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getTodolistCountService(pramams)) as ApiResponse<{ totalCount: number }>;
      if (res?.code === 200) {
        await dispatch({
          type: t.SET_COSTING_TODO_LIST_COUNT,
          payload: {
            totalCount: res.data?.totalCount as number,
            type: pramams.type,
          },
        });
        return true;
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
    return undefined;
  };

export const setCostingSelectedIds =
  (idsArr: string[]): CostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.SET_SELECTED_IDS_ARRAY,
        payload: idsArr,
      });
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
  };

export const filterSortData =
  (obj: Partial<import('./Costing.type').CostingFilterValues>): CostingThunkAction<Promise<void>> =>
  async (dispatch) => {
    try {
      await dispatch({
        type: t.SET_FILTER_SORT_DATA,
        payload: obj,
      });
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
  };

export const exportExcel =
  (params: CostingListParams): CostingThunkAction<Promise<void>> =>
  async () => {
    try {
      /* Double cast: the service's inferred type is AxiosResponse, but the response interceptor
         in services/api.services.js returns response.data, so the value here is the payload. */
      const res = (await exportExcelService(params)) as unknown as Blob | undefined;
      if (res) {
        fileSaver.saveAs(res, `Costing Report - ${moment().format('DD-MM-YYYY')}`);
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
  };

export const exportToPdf =
  (params: CostingListParams): CostingThunkAction<Promise<void>> =>
  async () => {
    try {
      const res = (await exportToPdfService(params)) as ApiResponse<{ fileName?: string; zipUrl?: string }>;
      if (res?.data?.fileName) {
        const fileName = res.data.fileName.toString();
        const fileUrl = `${imageUrl}/${res.data.zipUrl}`;

        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const fileObjectURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileObjectURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileObjectURL);
          })
          .catch((error) => console.error('Download error:', error));
      }
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
    }
  };

export const getSupplierBrands =
  (data: string): CostingThunkAction<Promise<NamedRef[] | undefined>> =>
  async (dispatch) => {
    try {
      const res = (await getSupplierBrandsService(data)) as ApiResponse<NamedRef[] & { errMsg?: string }>;
      if (res?.code === 200) {
        await dispatch({
          type: t.SUPPLIER_BRAND,
          payload: res.data as NamedRef[],
        });

        return res.data;
      }
      toasterMsg(res.data!.errMsg, 'danger');
    } catch (error) {
      toasterMsg(toMessage(error), 'danger');
    }
    return undefined;
  };

export const addMultiCommentOfCosting =
  (data: {
    costingIds: Array<{ costingId?: string | undefined; devOrderId?: string | undefined }>;
    commentMsg: string;
  }): CostingThunkAction<Promise<ApiResponse<{ errMsg?: string }>>> =>
  async () => {
    try {
      const res = (await addMultiCommentOfCostingService(data)) as ApiResponse<{ errMsg?: string }>;
      if (res.code === 200) {
        toasterMsg('Comment added successfully', 'success');
        return res;
      }
      toasterMsg(res.data!.errMsg, 'danger');
      return res;
    } catch (err) {
      toasterMsg(toMessage(err), 'danger');
      throw err;
    }
  };

export const getCostingStats =
  (params: CostingListParams | undefined): CostingThunkAction<Promise<CostingStats | null>> =>
  async (dispatch) => {
    try {
      const { pageIndex, pageSize, ...statsParams } = params ?? {};
      const res = (await getCostingStatsService(statsParams)) as ApiResponse<CostingStats>;
      if (res?.code === 200 && res?.data != null) {
        await dispatch({
          type: t.SET_COSTING_STATS,
          payload: res.data,
        });
        return res.data;
      }
      return null;
    } catch (err) {
      toasterMsg(err instanceof Error ? err.message : toMessage(err) || 'Failed to load costing stats', 'danger');
      return null;
    }
  };
